import React from "react";
import { Label, Error } from "@progress/kendo-react-labels";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";

const ValidationDateTimePicker = props => {

    const {validationState} = props;

    const inputProps = {...props};
    delete inputProps.label;

    const isError = !!validationState 
        && validationState.active 
        && validationState.showValidationMessage(props.name);

    return(<>
        <Label htmlFor={props.name}>{props.label}</Label>
        <DateTimePicker 
            {...inputProps}
        />
        { isError
            && <Error>{validationState.getValidationMessage(props.name)}</Error>}
    </>);
}

export default ValidationDateTimePicker;